
import { Component, Prop } from 'vue-property-decorator'
import PuSearchLink from '~~/apps/pu-links/link-search/PuSearchLink.vue'

@Component
export default class PuLowResultsSearchLink extends PuSearchLink {
  @Prop({ default: 'search' })
    category: string

  @Prop({ default: 'searchLowResult' })
    excludeType: string

  handleFacet() {
    // drop SEO /-/:facet/ from LowResults links
    return undefined
  }

  handleFilters() {
    // pass filters without any manipulation in combo with handleFacet it will
    // set facets correctly as a part of the query instead of the path
    return this.searchFiltersResolved
  }
}
